var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-steps--container" },
    [
      _c("CustomerFilterOptionsNew", {
        staticClass: "filter-steps--choices filter-status",
        attrs: { "filter-customer-id": _vm.customerIdFilterValue },
        on: { onCustomerSelected: _vm.handleCustomerFilterChange },
      }),
      _c("ServiceAreaFilterOptions", {
        staticClass: "filter-steps--choices filter-status",
        attrs: { "filter-service-area-id": _vm.serviceAreaFilterValue },
        on: { onSelectedServiceArea: _vm.handleServiceAreaFilterChange },
      }),
      _c("ChargingTypeOptions", {
        staticClass: "filter-steps--choices filter-status custom-md-field",
        attrs: { "label-name": "", placeholder: "Service Package" },
        on: { selectedOption: _vm.handleServicePackageChange },
      }),
      _c("OrderDateFilterOptions", {
        on: { onDateFilterChanged: _vm.handleDateFilterChange },
      }),
      _c(
        "md-field",
        { staticClass: "status-filter" },
        [
          _vm.orderStatuses
            ? _c("vue-select", {
                attrs: {
                  "data-testid": "order-status",
                  options: _vm.orderStatuses,
                  placeholder: "Status",
                  searchable: _vm.$root.isDesktop,
                  clearable: false,
                },
                model: {
                  value: _vm.filter.orderStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "orderStatus", $$v)
                  },
                  expression: "filter.orderStatus",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }